import { PromoModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import * as React from 'react';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { preparePromo } from './helpers';
import { usePromoDetailsConfig } from './hooks';
import { ActionButtonContainer } from './parts/ActionButtonContainer';
import { IPromoInfo } from '../../types/newbuildingPromos';
import { getCianMortgagePromoUrl } from '../../utils/motgageCalculator/getCianMortgagePromoUrl';
import { trackMortgageClick } from '../../utils/tracking/promos/trackMortgageClick';
import { useApplicationContext } from '../ApplicationContext';

export interface INewbuildingPromoDetailsContainerProps {
  offer: IOfferSchema;
  open: boolean;
  onClose: () => void;
  promo: IPromoInfo;
  placeType?: string;
}

export const NewbuildingPromoDetailsContainer: React.FC<
  React.PropsWithChildren<INewbuildingPromoDetailsContainerProps>
> = ({ open, offer, onClose, promo, placeType = 'newbuildingPromo' }) => {
  const { config } = useApplicationContext();
  const mortgagePromoUrl = getCianMortgagePromoUrl(config);

  const promoModalConfig = usePromoDetailsConfig();
  const preparedPromo = React.useMemo(() => preparePromo(promo), [promo]);

  const handleCianMortgageClick = React.useCallback(() => {
    trackMortgageClick({ promo, offer });
  }, [promo, offer]);

  /* istanbul ignore next */
  if (!preparedPromo) {
    return null;
  }

  return (
    <PromoModal
      open={open}
      onOpenChange={onClose}
      promo={preparedPromo}
      onCianMortgageClick={handleCianMortgageClick}
      controls={
        <ActionButtonContainer
          mortgagePromoUrl={mortgagePromoUrl}
          onMortgageClick={handleCianMortgageClick}
          offer={offer}
          promo={promo}
          dataTestId="PromoDetailsModalCallButton"
          placeType={placeType}
        />
      }
      config={promoModalConfig}
    />
  );
};
